import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncCareerV2 = loadable(() => import("./CareerV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncCareerV2 {...props} />
  </ErrorBoundary>
);
